import { useRef, useEffect } from 'react';

const usePrevious = (value) => {

    // Ref to hold previous value
    const ref = useRef();

    // When value changes, update ref
    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}

export default usePrevious;
